import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatBirthday } from "src/common/hooks/useFormatBirthDay";
import {
  useUpdateUser,
  useUserRegister,
} from "src/common/hooks/useUserRegister";
import { useViewport } from "src/common/hooks/ViewPort";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { PageContainer } from "src/components/organisms/contents";

const FixInfoPage: React.FC = () => {
  const navi = useNavigate();
  const { px } = useViewport();

  const { data: userInfo } = useUserRegister();
  /* 유저 정보 수정하기 */
  const { mutateAsync: updateUserInfo } = useUpdateUser();

  const genderRender = () => {
    if (userInfo?.gender === "M") return "남자";
    else if (userInfo?.gender === "W") return "여자";
    else return "";
  };

  // ── 임시 초기값
  const [birth, setBirth] = useState<string>(
    `${userInfo?.birthyear || ""}.${
      formatBirthday(userInfo?.birthday) || ""
    }` || ""
  );
  const [gender, setGender] = useState<string>(genderRender() || "");
  const [height, setHeight] = useState<string>(userInfo?.height || "");
  const [weight, setWeight] = useState<string>(userInfo?.weight || "");

  const onNumChange =
    (setter: (v: string) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      // 숫자만 허용 (소수점 필요하면 정규식 수정)
      const v = e.target.value.replace(/[^\d]/g, "");
      setter(v);
    };

  const handleSave = () => {
    const h = Number(height);
    const w = Number(weight);
    if (!h || !w) {
      alert("키와 몸무게를 올바르게 입력해주세요.");
      return;
    }

    updateUserInfo({ height: h, weight: w });
    navi("/mysetting");
  };
  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <SubConHeader
          title="건강 정보"
          onClickArrow={() => navi("/mysetting")}
        />

        {/* 폼 카드 */}
        <div
          style={{
            marginTop: px(12),
            background: "#FFFFFF",
            borderRadius: px(14),
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            padding: px(14),
          }}
        >
          {/* 생년월일 (읽기 전용) */}
          <FieldRow
            label="생년월일"
            control={
              <input
                value={birth}
                readOnly
                style={roInputStyle(px)}
                onChange={(e) => setBirth(e.target.value)}
              />
            }
            px={px}
          />

          {/* 성별 (읽기 전용) */}
          <FieldRow
            label="성별"
            control={
              <input
                value={gender}
                readOnly
                style={roInputStyle(px)}
                onChange={(e) => setGender(e.target.value)}
              />
            }
            px={px}
          />

          {/* 키 (수정 가능) */}
          <FieldRow
            label="키"
            control={
              <div style={{ position: "relative" }}>
                <input
                  value={height}
                  onChange={onNumChange(setHeight)}
                  inputMode="numeric"
                  style={editInputStyle(px)}
                />
                <span style={unitStyle(px)}>cm</span>
              </div>
            }
            px={px}
          />

          {/* 몸무게 (수정 가능) */}
          <FieldRow
            label="몸무게"
            control={
              <div style={{ position: "relative" }}>
                <input
                  value={weight}
                  onChange={onNumChange(setWeight)}
                  inputMode="numeric"
                  style={editInputStyle(px)}
                />
                <span style={unitStyle(px)}>kg</span>
              </div>
            }
            px={px}
          />
        </div>

        {/* 안내 배너 */}
        {/* <div
          style={{
            marginTop: px(10),
            background: "#ECECEC",
            color: "#6B7280",
            borderRadius: px(10),
            padding: `${px(10)}px`,
            display: "flex",
            alignItems: "center",
            gap: px(8),
            fontSize: px(12),
          }}
        >
          <div
            style={{
              width: px(20),
              height: px(20),
              borderRadius: "50%",
              background: "#D1D5DB",
              display: "grid",
              placeItems: "center",
              flex: "0 0 auto",
            }}
            aria-hidden
          >
            i
          </div>
          <div>건강검진정보 연동 시 키·몸무게가 자동 입력됩니다.</div>
        </div> */}

        {/* 하단 저장 바 */}
        <div
          style={{
            width: "100%",
            maxWidth: "45rem",
            position: "fixed",
            left: "50%",
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            padding: px(16),
            background: "transparent",
            transform: "translateX(-50%)",
          }}
        >
          <div style={{ width: "100%" }}>
            <button
              onClick={handleSave}
              style={{
                width: "100%",
                height: px(50),
                background: "#F97316",
                color: "#fff",
                border: "none",
                borderRadius: px(10),
                fontSize: px(15),
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 6px 14px rgba(0,0,0,0.1)",
              }}
            >
              저장
            </button>
          </div>
        </div>
      </>
    </PageContainer>
  );
};

/* ---------- 서브 컴포넌트 ---------- */

const FieldRow: React.FC<{
  label: string;
  control: React.ReactNode;
  px: (n: number) => number;
}> = ({ label, control, px }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: `${px(90)}px 1fr`,
      alignItems: "center",
      gap: px(12),
      padding: `${px(8)}px 0`,
      borderBottom: `${px(1)}px solid #F3F4F6`,
    }}
  >
    <div style={{ fontSize: px(13), color: "#111827" }}>{label}</div>
    <div>{control}</div>
  </div>
);

const roInputStyle = (px: (n: number) => number): React.CSSProperties => ({
  width: "100%",
  height: px(40),
  borderRadius: px(12),
  border: `${px(1)}px solid #E5E7EB`,
  background: "#F9FAFB",
  color: "#6B7280",
  fontSize: px(14),
  padding: `0 ${px(12)}px`,
});

const editInputStyle = (px: (n: number) => number): React.CSSProperties => ({
  width: "100%",
  height: px(40),
  borderRadius: px(12),
  border: `${px(1)}px solid #E5E7EB`,
  background: "#FFFFFF",
  color: "#111827",
  fontSize: px(14),
  padding: `0 ${px(40)}px 0 ${px(12)}px`, // 오른쪽 단위 공간 확보
  outline: "none",
});

const unitStyle = (px: (n: number) => number): React.CSSProperties => ({
  position: "absolute",
  right: px(12),
  top: "50%",
  transform: "translateY(-50%)",
  color: "#6B7280",
  fontSize: px(13),
});

export default FixInfoPage;
